import React from 'react';
import { IntegrationProvider, JiraConfig } from 'api/integrations';
import { ProjectCreateLinkedResource } from 'api/project';
import { Select } from 'components/atoms/select';
import { useTranslation } from 'hooks/use-translation';
import { FormItem } from './common.styles';

/**
 * Move to better file structure when more integrations come.
 * TODO: this will evolve into array when more integrartions are added
 * for now its unclear how will this grow, so keeing it as for the use-case (jira)
 */
const field = {
  fieldName: 'Issue Type',
  fieldId: 'epic',
};

type JiraEpicMapping = {
  options: any;
  jiraConfig: JiraConfig;
  isLoading?: boolean;
  hidden?: boolean;
};

type JiraEpicOption = {
  value: string;
  label: string;
} & ProjectCreateLinkedResource;

export const JiraFields = ({
  options,
  jiraConfig,
  isLoading,
  hidden,
}: JiraEpicMapping): JSX.Element => {
  const jraEpicTitle = useTranslation(
    'settings.integrations.jira.mapping.modal.title',
  );

  return (
    <FormItem name="jiraEpicMapping" label={jraEpicTitle} hidden={hidden}>
      <Select
        options={(options || [])?.map(
          (epic): JiraEpicOption => ({
            value: epic.id,
            label: epic.name,
            externalIntegrationType: IntegrationProvider.Jira,
            externalResourceType: field.fieldId,
            externalResourceId: epic.id,
            integrationId: jiraConfig.integrationId,
            enabled: true,
            context: {
              jiraProjectId: jiraConfig.settingsMeta.fixedProjectId,
            },
          }),
        )}
        isLoading={isLoading}
      />
    </FormItem>
  );
};
